import { render, staticRenderFns } from "./Efectividad.vue?vue&type=template&id=1a1363eb&scoped=true&"
import script from "./Efectividad.vue?vue&type=script&lang=js&"
export * from "./Efectividad.vue?vue&type=script&lang=js&"
import style0 from "./Efectividad.vue?vue&type=style&index=0&id=1a1363eb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1363eb",
  null
  
)

export default component.exports